<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar">
  <!-- BEGIN scrollbar -->
   <div class="app-sidebar-content ps ps--active-y" data-scrollbar="true" data-height="100%" style="height: 100%; display: flex; flex-direction: column;" data-init="true">
    <ng-container *ngIf="!isPublic && authService.isAuthenticated()">
      
      <!-- BEGIN mobile-toggler -->
      <div class="mobile-toggler">
        <button type="button"  (click)="app.menuOpen = !app.menuOpen" class="menu-close btn btn-outline-primary" data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud">
          <i class="bi bi-arrow-left"></i>
        </button>
      </div>
      <!-- END mobile-toggler -->

      <!-- BEGIN menu -->
      <div class="menu" style="flex: 1; overflow-y: auto;">
        <ng-container *ngFor="let section of configService.sections">
          <div *ngIf="authService.canViewSection(section)" class="menu-header">{{section.name}}</div>
          <ng-container *ngFor="let page of section.pages; let index = index">
            <div class="menu-item" [ngClass]="{ 'has-sub': page.children && page.children, 'active':childActive(page, activeRoute)}"
              *ngIf="page.visible && authService.canViewPage(page)">

             

              <!--Admin: {{page.isAdmin && authService.isAdmin()}}
              <br/>
              Role: {{page.role == null && authService.isInRole(page.role)}}
              <br/>
              Owner: {{page.isOwner == null && authService.isOwner()}}-->
              <a class="menu-link"  [routerLink]="page.route ? [page.route] : []" *ngIf="page.children == null || page.children.length == 0" [routerLink]="page.route ? [page.route] : []" (click)="openDropdown(index)"
                data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud" (click)="app.menuOpen = false">
                <span class="menu-icon"><i [ngClass]="page.icon"></i></span>
                <span class="menu-text">{{ page.name }}</span>
              </a>
              <a class="menu-link" (click)="toggle($event, page)" *ngIf="page.children && page.children.length > 0" [routerLink]="page.route ? [page.route] : []" (click)="openDropdown(index)"
                data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud">
                <span class="menu-icon"><i [ngClass]="page.icon"></i></span>
                <span class="menu-text">{{ page.name }}</span>
                <span class="menu-caret"><b class="caret"></b></span>
              </a>
              <div class="menu-submenu" [style.display]="page.toggled ? 'block' : 'none'">
                <div class="menu-item" *ngFor="let subPage of page.children" [ngClass]="{'active':subPage.route == activeRoute}">
                  <a class="menu-link" (click)="app.menuOpen = !app.menuOpen" [routerLink]="subPage.route ? [subPage.route] : []" 
                    data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud" (click)="app.menuOpen = false" >
                    <span class="menu-text">{{subPage.name}}</span>
                  </a>
                </div>
              </div> 
            </div>
          </ng-container>
        </ng-container>
        
      </div>
      <!-- END menu -->
      <div style="margin-top: auto; padding: 1rem; text-align: center;color:grey" class="menu-item">
        {{configService.settings.version}}
      </div>
    </ng-container>
  </div>
  <!-- END scrollbar -->
</div>
<!-- END #sidebar -->
  
<!-- BEGIN mobile-sidebar-backdrop -->
<button class="app-sidebar-mobile-backdrop" data-toggle-target=".app" data-toggle-class="app-sidebar-mobile-toggled"></button>
<!-- END mobile-sidebar-backdrop -->